import { useQuery } from '@tanstack/react-query';
import { useOrganization } from '@/contexts/OrganizationContext';
import { campaignRepository } from '../repositories/campaign.repository';
import { campaignKeys } from '../services/campaign.keys';
import type { CampaignWithContact } from '../types/campaign.types';

export type { CampaignWithContact };

export function useCampaignWithContact(campaignId: string) {
  const { currentOrganization } = useOrganization();

  return useQuery({
    queryKey: campaignKeys.withContact(campaignId),
    queryFn: async () => {
      return campaignRepository.getById(campaignId, currentOrganization?.id);
    },
    enabled: !!campaignId,
    staleTime: 0,
    gcTime: 5 * 60 * 1000,
    refetchOnWindowFocus: true,
  });
}
